import React from 'react'
import { format } from 'date-fns'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { IconSparkles } from '@tabler/icons-react'
import { sortBy, toString } from 'lodash'

import { CHANNEL_TYPE, dateFormat } from '@/utils/constants'
import { setHardSelectedEvent } from '@/reducers/media/media.actions'
import { JumpToPill } from '@/components/media/components/JumpToPill'
import { Pill } from '@/components/pills/Pill'
import { Banner } from '@/components/banners/Banner'

import { formatTime, updateCallExplorerParams, UNIX_TIMESTAMP_LENGTH } from './helpers'

export const QAScoreCriteriaTimestampButton = ({ scoreId, callId, criteriaScore, callType }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const { callExplorer } = useSelector((state) => state.callSearch)
  const { associatedCallIds } = callExplorer
  const hasTimestamp = Boolean(criteriaScore.ai_anchor_time)
  const sortedassociatedCallIds = sortBy(associatedCallIds)
  const hasMessageTimestamp =
    hasTimestamp &&
    callType !== CHANNEL_TYPE.CALL &&
    criteriaScore.ai_anchor_time.toString().length === UNIX_TIMESTAMP_LENGTH
  const hasMulticallTimestamp =
    hasTimestamp &&
    criteriaScore.multicall_call_id &&
    toString(callId) !== toString(criteriaScore.multicall_call_id)
  const associatedCallindex = hasMulticallTimestamp
    ? sortedassociatedCallIds.findIndex((id) => id === criteriaScore.multicall_call_id)
    : -1

  if (hasMessageTimestamp) {
    return (
      <JumpToPill
        dataTestId={criteriaScore.id}
        onClick={() => {
          updateCallExplorerParams(location, history, {
            highlightedMessage: criteriaScore.ai_anchor_time,
          })
        }}
        formattedTime={format(new Date(criteriaScore.ai_anchor_time * 1000), dateFormat.long)}
        identity="message"
      />
    )
  }

  if (hasMulticallTimestamp && associatedCallindex !== -1) {
    return (
      <Banner informative>
        <p className="mb">
          This moment is from{' '}
          <Link to={`/calls/${criteriaScore.multicall_call_id}`}>
            Call {associatedCallindex + 1}
          </Link>{' '}
          and will take you to a new page.
        </p>
        <Pill
          className="clickable"
          dataTestId="jump-to-call-event-pill-multicall"
          informative
          small
          icon={<IconSparkles />}
          onClick={() => {
            history.push(
              `/calls/${criteriaScore.multicall_call_id}?timestamp=${criteriaScore.ai_anchor_time}&tab=qa_scores&scorecardId=${scoreId}`
            )
          }}
        >
          {`Jump to ${formatTime(criteriaScore.ai_anchor_time)} of Call ${associatedCallindex + 1}`}
        </Pill>
      </Banner>
    )
  }

  if (hasTimestamp) {
    return (
      <JumpToPill
        dataTestId={criteriaScore.id}
        onClick={() => {
          updateCallExplorerParams(location, history, {
            criteriaScoreId: criteriaScore.id,
            timestamp: criteriaScore.ai_anchor_time,
          })
          dispatch(
            setHardSelectedEvent({
              id: criteriaScore.id,
              timestamp: criteriaScore.ai_anchor_time,
              displayText: criteriaScore.name,
              section: 'QACopilot',
            })
          )
        }}
        formattedTime={formatTime(criteriaScore.ai_anchor_time)}
      />
    )
  }

  if (!hasTimestamp) {
    return (
      <Pill small icon={<IconSparkles />}>
        Not present in timestamp
      </Pill>
    )
  }

  return null
}
